import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Small delay to let Chartkick's own initialization run first
    setTimeout(() => {
      this.initializeCharts()
    }, 100)
  }
  
  initializeCharts() {
    // Find all chart elements within this controller's element
    const chartElements = this.element.querySelectorAll('[data-chart-json]')
    
    chartElements.forEach(element => {
      // Check if already initialized (has canvas or svg inside)
      if (!element.querySelector('canvas') && !element.querySelector('svg')) {
        // Re-trigger Chartkick initialization for this specific element
        if (window.Chartkick) {
          window.Chartkick.createChart(element.id, element)
        }
      }
    })
  }
}